/******/ (() => { // webpackBootstrap
/*!***************************************!*\
  !*** ./scripts/product-bulk-order.js ***!
  \***************************************/
var productWrapper = document.querySelector('product-info');
document.querySelector('.button-bulk-order-open').addEventListener('click', function (e) {
  productWrapper.querySelector('.product-details').classList.add('hidden');
  productWrapper.querySelector('.bulk-order-form-modal').classList.remove('hidden');
});
document.querySelector('.button-bulk-order-close').addEventListener('click', function (e) {
  productWrapper.querySelector('.product-details').classList.remove('hidden');
  productWrapper.querySelector('.bulk-order-form-modal').classList.add('hidden');
});
var inputValueWrapper = document.querySelectorAll('.td-input__inner');
var inputValue = document.querySelectorAll('.td-input-quantity');
var bulkButton = document.querySelector('.button--bulk-add');
inputValue.forEach(function (input) {
  input.addEventListener('change', function (i) {
    for (i = 0; i < inputValue.length; i++) {
      if (input.value > 0) {
        bulkButton.disabled = false;
        break;
      } else {
        bulkButton.disabled = true;
      }
    }
  });
});
/******/ })()
;